import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import './Nav.css';

function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const navH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-h')) || 64;
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - navH, behavior: 'smooth' });
}

export default function Nav() {
  const { lang, setLang, t } = useLang();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const close = () => setMenuOpen(false);

  const goSection = (section) => {
    close();
    if (window.location.pathname !== '/') {
      navigate('/', { state: { scrollTo: section } });
    } else {
      scrollToId(section);
    }
  };

  return (
    <>
      <nav className="main-nav">
        <NavLink to="/" className="nav-logo" onClick={() => { close(); window.scrollTo(0, 0); }}>
          <img src="/gemiya-logo.png" alt="Gemiya" className="nav-logo-img" />
        </NavLink>
        <div className="nav-right">
          <ul className="nav-links">
            <li><NavLink to="/" end onClick={() => { close(); window.scrollTo(0, 0); }}>{t('nav.home')}</NavLink></li>
            <li><button className="nav-link-btn" onClick={() => goSection('specials-section')}>{t('nav.specials')}</button></li>
            <li><NavLink to="/menu" onClick={close}>{t('nav.menu')}</NavLink></li>
            <li><button className="nav-link-btn" onClick={() => goSection('story-section')}>{t('nav.about')}</button></li>
            <li><NavLink to="/reservations" className="nav-cta" onClick={close}>{t('nav.reserve')}</NavLink></li>
          </ul>
          <div className="lang-switcher">
            <button className={"lang-btn" + (lang==='fr'?' active':'')} onClick={() => setLang('fr')}>FR</button>
            <button className={"lang-btn" + (lang==='en'?' active':'')} onClick={() => setLang('en')}>EN</button>
          </div>
          <button className={"nav-hamburger" + (menuOpen?' open':'')} onClick={() => setMenuOpen(o=>!o)} aria-label="Toggle menu">
            <span/><span/><span/>
          </button>
        </div>
      </nav>
      {menuOpen && (
        <>
          <div className="nav-backdrop" onClick={close} />
          <div className="nav-drawer">
            <NavLink to="/" end onClick={() => { close(); window.scrollTo(0, 0); }}>{t('nav.home')}</NavLink>
            <button className="nav-link-btn" onClick={() => goSection('specials-section')}>{t('nav.specials')}</button>
            <NavLink to="/menu" onClick={close}>{t('nav.menu')}</NavLink>
            <button className="nav-link-btn" onClick={() => goSection('story-section')}>{t('nav.about')}</button>
            <NavLink to="/reservations" className="nav-drawer-cta" onClick={close}>{t('nav.reserve')}</NavLink>
          </div>
        </>
      )}
    </>
  );
}
